<template>
  <v-text-field
    v-model="searchText"
    prepend-inner-icon="mdi-magnify"
    class="mt-4"
    name="search"
    label="Wyszukaj"
    clearable
    light
    solo
    @input="search"
  />
</template>

<script>
import { debounce } from 'debounce';

// @vuese
// Wyszukiwarka
// @group Table
export default {
  data() {
    return { searchText: this.$route.query.search || '' };
  },
  methods: {
    // @vuese
    // Wyszukuje wpisaną frazę
    search: debounce(function() {
      this.updateRoute();
    }, 500),

    // @vuese
    // Aktualizuje route
    updateRoute() {
      this.$router.replace({ ...this.$route, query: { ...this.$route.query, search: this.searchText, page: 1 } });
    }
  }
};
</script>
